module.exports = __webpack_public_path__ + "img/wait.86bae762.jpg";